var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Head',{attrs:{"title":"Admin"}}),_vm._v(" "),_c('v-container',{staticClass:"grey lighten-5"},[_c('v-card',[_c('v-card-title',[_vm._v("\n            Admin\n        ")])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }